import { useState } from 'react'
import { useSearch } from 'wouter'
import { useModuleLabel } from '../lib/useModuleLabel'
import { useActionsPortail } from '../contexts/navigation'
import RinaContextCard from '../components/RinaContextCard'
import TabPane from '../components/TabPane'
import MarcheProducerEvents from '../components/marche/MarcheProducerEvents'
import MarcheProducerStand from '../components/marche/MarcheProducerStand'
import MarcheProducerHisto from '../components/marche/MarcheProducerHisto'
import PastilleCompte from '../components/PastilleCompte'
import FondPage from '../components/FondPage'
import EnteteModule from '../components/EnteteModule'
import BarreOnglets from '../components/BarreOnglets'
import { MVP } from '../mvp'

// Module Evenements — facette PRODUCTEUR (v7.1 sujet 3, extraite de
// MarcheModule en S46) : Événements / Mon stand / Historique — inscription +
// confirmation datee du stand, vitrine de reference, CA/commission.
// AUCUNE prop ni garde : la route vit sous /producteur (ADR-068, ZoneProducteur
// bascule la casquette), les actions viennent des contextes, l'etat initial
// (navigation croisee « Ma facturation » v7.2.3) de `marcheProducerInit`.

// Accents via les jetons (--c-teal / --c-green) — pas d'hex en dur

export default function MarcheModuleProducteur() {
  const { fermerModule, handleRinaClick } = useActionsPortail()

  const tc = 'text-ink'
  const glass = 'panneau-verre'

  // Nom du lieu (ADR-062) — pilote par le backend, servi depuis le cache SWR.
  const module = useModuleLabel('MARCHE')

  // Onglet actif + toast. Query params (?tab=historique&sel=...) : ouvrir
  // directement Historique > detail depuis une facture actionnable (v7.2.3) —
  // deep-linkable, plus d'etat pose avant de naviguer.
  const params = new URLSearchParams(useSearch())
  const tabDemande = params.get('tab')
  const [pTab, setPTab] = useState(
    tabDemande && (tabDemande !== 'historique' || MVP.PRODUCTEUR_HISTORIQUE) ? tabDemande : 'evenements',
  )
  const [pFlash, setPFlash] = useState(null)
  const pToast = (msg) => {
    setPFlash(msg)
    setTimeout(() => setPFlash(null), 2800)
  }

  const onExit = () => fermerModule()
  const onGoOffers = () => { fermerModule('offers'); window.scrollTo(0, 0) }

  const pTabs = [
    { k: 'evenements', e: '🎪', l: 'Événements' },
    { k: 'stand', e: '🪧', l: 'Mon stand' },
    // MVP (S62) : l'Historique (declaration de CA, commission) suit son drapeau
    ...(MVP.PRODUCTEUR_HISTORIQUE ? [{ k: 'historique', e: '🧾', l: 'Historique' }] : []),
  ]
  const pRina =
    pTab === 'stand'
      ? "Votre stand de référence. Activez ou coupez un produit ; c'est ce que je proposerai par défaut à chaque inscription."
      : pTab === 'historique'
        ? 'Vos marchés passés : déclarez votre CA et réglez votre commission. Je calcule tout pour vous.'
        : "Inscrivez-vous aux prochains marchés. À chaque inscription, je vous propose votre stand pré-rempli — vous n'avez qu'à confirmer."

  return (
    <FondPage halos>

      <div className="pb-28 max-w-md mx-auto relative z-[2]">
        <EnteteModule
          retour={{ label: 'Lyannaj', onClick: onExit }}
          titre={`${module.emoji} ${module.nom}`}
        >
          <PastilleCompte />
        </EnteteModule>

        <div className="px-4 pt-1">
          <RinaContextCard onClick={handleRinaClick} message={pRina} />
          {/* Onglets gardes EN VIE (S29, E-13) : changer d'onglet ne demonte plus
              la page — l'etat et les donnees survivent, le retour est instantane.
              La feuille « Confirmer mon stand » sort par createPortal : elle
              n'est pas concernee par le masquage (cf. TabPane). */}
          <TabPane actif={pTab === 'evenements'}>
            <MarcheProducerEvents onToast={pToast} />
          </TabPane>
          <TabPane actif={pTab === 'stand'}>
            <MarcheProducerStand onGoOffers={onGoOffers} onToast={pToast} />
          </TabPane>
          {MVP.PRODUCTEUR_HISTORIQUE && (
          <TabPane actif={pTab === 'historique'}>
            <MarcheProducerHisto onToast={pToast} initialSelId={params.get('sel')} />
          </TabPane>
          )}
        </div>
      </div>

      {/* Bottom-nav facette producteur (proto : Événements / Mon stand / Historique) */}
      <BarreOnglets onglets={pTabs} actif={pTab} onSelect={setPTab} />

      {pFlash && (
        <div
          className="glass-dark fixed left-1/2 -translate-x-1/2 rounded-[14px] text-[13px] font-semibold text-center z-[70]"
          style={{ bottom: 90, padding: '11px 18px', maxWidth: 340, color: 'rgb(var(--c-creme))' }}
        >
          {pFlash}
        </div>
      )}
    </FondPage>
  )
}
